import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrl: './text-area.component.scss'
})
export class TextAreaComponent {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() keyName: string = '';
  @Input() value: string[] = [];
  @Input() valueType: 'array' | 'string' = 'string';
  
  @Output() valueChange = new EventEmitter<{keyName: string, value: string[]}>();

  textareaValue: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && this.value) {
      this.textareaValue = this.arrayToString(this.value);
    }
  }

  private arrayToString(arr: string[]): string {
    if (!arr || arr.length === 0) {
      return '';
    }
    return arr.join(',\n');
  }

  private stringToArray(str: string): string[] {
    if (!str || str.trim() === '') {
      return [];
    }
    
    return str
      .replace(/\r?\n/g, ',')
      .replace(/,+/g, ',')
      .split(',')
      .map(item => item.trim())
      .filter(item => item !== '');
  }

  public countItems(): number {
    return this.stringToArray(this.textareaValue).length;
  }

  onInput(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    this.textareaValue = target.value;
    
    const arrayValue = this.stringToArray(this.textareaValue);
    
    this.valueChange.emit({
      keyName: this.keyName,
      value: arrayValue
    });
  }
}